module.exports = __webpack_public_path__ + "static/media/searchIcon.4806e24a.svg";